module.exports = __webpack_public_path__ + "media/books/ArtBooksProduct-x2-475578a0.png";